import Swal from "sweetalert2";

export async function NotifyConfirm(
  type,
  text,
  callback,
  title = "Are you change it ?"
) {
  const result = await Swal.fire({
    title: title,
    text: text === title ? "Oops..." : text,
    icon: type,
    // timer: 1500,
    showCancelButton: true,
    cancelButtonText: "Cancel",
    cancelButtonColor: "#d33",
    showConfirmButton: true,
    confirmButtonText: "Yes, Sure !",
    reverseButtons: true,
    html: text,
  });
  callback(result);
}

export async function NotifyDeployCache(type, title, text, callback) {
  const result = await Swal.fire({
    title: title,
    text: text,
    icon: type,
    // timer: 1500,
    showCancelButton: true,
    cancelButtonText: "Cancel",
    cancelButtonColor: "#ccc",
    showConfirmButton: true,
    confirmButtonColor: "#ff6700",
    confirmButtonText: "Yes, Sure !",
    reverseButtons: true,
    html: text,
  });

  callback(result);
}

export async function NotifyClearCache(type, title, text, callback) {
  const result = await Swal.fire({
    title: title,
    text: text,
    icon: type,
    // timer: 1500,
    showCancelButton: true,
    cancelButtonText: "Cancel",
    showConfirmButton: true,
    confirmButtonColor: "#22bb33",
    confirmButtonText: "Yes, Sure !",
    reverseButtons: true,
    html: text,
  });
  callback(result);
}

export async function NotifyReLogin(type, text, callback) {
  const result = await Swal.fire({
    title: text,
    text: "Oops...",
    icon: type,
    // timer: 1500,
    showConfirmButton: true,
    confirmButtonText: "Ok",
    reverseButtons: true,
  });
  callback(result);
}

export async function Notify(type, text) {
  return await Swal.fire({
    title: text,
    text: "Oops...",
    icon: type,
    showConfirmButton: false,
    timer: 1500,
    customClass: {
      container: "my-swal",
    },
  });
}

export function Toast(type, text) {
  const toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  return toast.fire({
    icon: type,
    title: text,
  });
}

export const ToastSyncData = () => {
  Swal.fire({
    title: "Dữ Liệu Đang Được Đồng Bộ!",
    html: "popup sẽ được đóng khi hoàn tất",
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });
};
